// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1RP0N","dragIcon":"Choice_dragIcon__3P3ZI","left":"Choice_left__22xSV","input":"Choice_input__3Q1tR"};